import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Box, Typography, Card, CardContent, CircularProgress } from '@mui/material';
import { RegistrationPlate } from '@/components/common';
import { VehicleTechnicalDataPanel } from '@/components/vehicles/technical-data';
import { useVehicle } from '@/hooks';

export default function VehicleDetailPage() {
  const { id } = useParams<{ id: string }>();
  const { t } = useTranslation('vehicles');
  const { t: tc } = useTranslation('common');
  const { data: vehicle, isLoading } = useVehicle(id);

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }} role="status" aria-label={tc('loading')}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
        <Typography variant="h4" fontWeight={600}>{t('vehicle')}</Typography>
        {vehicle && <RegistrationPlate registrationNumber={vehicle.registrationNumber ?? '-'} />}
      </Box>
      {vehicle && (
        <Typography variant="body1" color="text.secondary" gutterBottom>
          {vehicle.make} {vehicle.model} {vehicle.year}
        </Typography>
      )}
      {vehicle && (
        <Box sx={{ mt: 3 }}>
          <VehicleTechnicalDataPanel
            vehicleId={vehicle.id}
            make={vehicle.make}
            model={vehicle.model}
            hasVin={Boolean(vehicle.vin)}
          />
        </Box>
      )}
      <Card sx={{ mt: 3 }}>
        <CardContent sx={{ minHeight: 400, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Typography color="text.secondary">{t('detailPlaceholder')}</Typography>
        </CardContent>
      </Card>
    </Box>
  );
}
